module.exports = __webpack_public_path__ + "images/canonical-card/trello-attachment-icon.5eb536632630ab0ae830.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/trello-attachment-icon.svg
// module id = wMzv
// module chunks = 0